module.exports = __webpack_public_path__ + "img/undefined.a050b9c3.svg";